/**
 * @owner @Appboy/frontend-ix
 */

import type { FeatureName } from "@lib/featureFlipper";

// if you update allowed locales, update:
// app/assets/js/lib/ab-18n.js.coffee
// .storybook/preview.js
// config/webpack/i18n/missingKeyHandler.js
// src/i18n.ts add imports for the locale data from i18next
// app/javascript/src/lib/libraries.ko.js update formatjs polyfills
export const locales: ["en", "ja", "fr", "ko", "pt-br", "es", "de"] = ["en", "ja", "fr", "ko", "pt-br", "es", "de"];
export type AllowedLocales = (typeof locales)[number];
export interface LocaleEntry {
  /** The language's name, in that language */
  localizedName: string;
  /** feature flipper that is used to show/hide, or false if globally available */
  featureFlipper: FeatureName | false;
}
// PLEASE KEEP IN SYNC WITH get_valid_languages_for_company in
// shared_code/lib/shared/braze/i18n/helpers.rb.rb
//
// Note that the order of the keys matters, as it determines the order in which
// these show up in the dashboard and notification language selector dropdowns.
// The same order should be used in dashboard/app/views/layouts/dashboard.html.erb.
export const localeToLanguageMap: { [locale in AllowedLocales]: LocaleEntry } = {
  de: {
    localizedName: "Deutsch",
    featureFlipper: false,
  },
  en: {
    localizedName: "English",
    featureFlipper: false,
  },
  es: {
    localizedName: "Español",
    featureFlipper: false,
  },
  fr: {
    localizedName: "Français",
    featureFlipper: false,
  },
  ja: {
    localizedName: "日本語",
    featureFlipper: false,
  },
  ko: {
    localizedName: "한국어",
    featureFlipper: false,
  },
  "pt-br": {
    localizedName: "Português (Brasil)",
    featureFlipper: false,
  },
};
